/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './TeamForm.css';

import {
  upload,
} from '../../actions';


class MemberForm extends OzFormComponent {
  static fields = [
    'email',
  ]

  renderBody() {
    return (
      <div className="MemberForm">
        {this.renderFormGroup('Team member email', 'email', 'email')}
      </div>
    );
  }
}


class TeamForm extends OzFormComponent {

  static fields = [
    'members',
    'name',
    'photo',
  ]

  options = {
    members: {
      init: {
        email: null,
      }
    },
  }

  renderMembers() {
    let members = this.state.members || [];
    let i = 0;
    let nodes = members.map(member => {
      let index = i;
      i++;
      return (
        <MemberForm
          key={member.id}
          index={member.id}
          errors={this.props.errors ? this.props.errors.members[index] : null}
          part={true}
          values={member}
          cancelRender={() => <Glyphicon className="minus-sign" glyph="minus-sign" />}
          onCancel={() => this.removeMany(member.id, 'members')}
          onChange={(values) => this.updateMany(member.id, values, 'members')}
        />
      );
    });

    return (
      <div className="members-wrapper">
        {nodes}
      </div>
    );
  }

  renderBody() {
    return (
      <div className="TeamForm">
        {this.renderFormGroup('What is the team name?', 'text', 'name')}
        {this.renderFormGroup('Team photo (optional)', 'image', 'photo')}
        {this.renderMembers()}
        <div className="add-member">
          <Button onClick={() => this.addMany('members')}>Add Team Member</Button>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    upload: (...args) => dispatch(upload(...args)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TeamForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/TeamForm.js
 **/